/**
 * @file Creates a shared interface for all LightHandlers.
 *       The LightHandlerInterface must be implemented by all LightHandlers.
 *       All described methods must be implemented.
 * 
 * @module LightHandlerInterface
 * @author Michael Oppitz
 */

/**
 * Interface for the LightHandler.
 * The LightHandler implements all functionality related to the lights.
 * 
 * //@interface LightHandlerInterface
 */
class LightHandlerInterface {
  /**
   * The constructor for the {@link module:LightHandlerInterface~LightHandlerInterface}.
   * @constructs module:LightHandlerInterface~LightHandlerInterface
   */
  constructor() { }

  /**
   * Pause the light updates.
   *
   * @abstract
   */
  pause() { }

  /**
   * Resume the light updates.
   *
   * @abstract
   */
  resume() { }

  /**
   * Destroy the lightHandler.
   *
   * @abstract
   */
  destroy() { }




  /**
   * Updates the position of the first directional light according to the bounding sphere.
   *
   * @abstract
   * @param {THREE.Sphere} bs The bounding sphere around the scene
   */
  adjustToBoundingSphere(bs) { }

  /**
  * IMPORTANT: This function must only be called from RenderingHandler.Hook->shadows.
  * Toggles the shadows of the lights.
  *
  * @abstract
  * @param {Boolean} toggle To what to set the mode
  * @returns {Boolean} If the mode was successfully set
  */
  setToggleLightShadows(toggle) { }

  /**
   * Toggles all lights in the scene.
   *
   * @abstract
   * @param {Boolean} toggle To what to set the mode
   */
  toggleLights(toggle) { }
}

module.exports = LightHandlerInterface;